import UCL from '../Helpers/UserClientLibs';
const useLogout = () => {

    const logoutHandler = async (isVoluntary) => {
        return await UCL.LogoutAsync({ embedShortCircuit: true, redirect: "login", isVoluntary })
    };

    return logoutHandler;
}

export default useLogout;
